import CONSTANTS from '../constants'
import {  postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import getConfigDetails from '../../services/config'
import { osName, osVersion, browserName, deviceType, mobileModel, mobileVendor } from 'react-device-detect'

// Calls the API to get EVENT Initials
export const storeEventLog = (postData) => (dispatch) => {
	dispatch({ type: CONSTANTS.EVENT_LOG_REQUEST })
	return postRequest(APICONFIG.getEventLogUrl,postData).then((res) => {		
		dispatch({ type: CONSTANTS.EVENT_LOG_SUCCESS, data: res })
		return res
	}).catch(() => {
		dispatch({ type: CONSTANTS.EVENT_LOG_FAILURE })
	})
}

// Calls the API to get User IP
export const getUserIp = () => (dispatch) => {
	dispatch({ type: CONSTANTS.GET_IP_REQUEST })
	return fetch('https://geolocation-db.com/json/')
          .then((response) => response.json())
          .then((data) => {
			dispatch({ type: CONSTANTS.GET_IP_SUCCESS, data: data })
			return data
	}).catch(() => {
		dispatch({ type: CONSTANTS.GET_IP_FAILURE })
	})
}



export const addEventLog = (data, title) => (dispatch) => {
    const device_config = {
        browser: browserName,
        device: deviceType,
        model: mobileModel,
        brand: mobileVendor,
        os: osName,
        osVersion: osVersion
    }
    const updatedData = {...data, ...device_config}
    const payload = {
        'error_message': JSON.stringify(updatedData),
        'facility_id': getConfigDetails.CLIENT_SECRET,
        'event_name': title,
        'user_id': 0,
        'user_ip': localStorage.getItem('user_ip'),
        'device_type': 'web'
    }
    dispatch({ type: CONSTANTS.ADD_EVENT_LOG_REQUEST })
    return postRequest(APICONFIG.getEventLogUrl, payload).then((res) => {
        dispatch({ type: CONSTANTS.ADD_EVENT_LOG_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.ADD_EVENT_LOG_FAILURE })
        return err
    })
}